import './main.less';
import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm, Field } from 'redux-form';

import TextField from '../../../shared/form-elements/textarea';
import SelectField from '../../../shared/form-elements/select/field';
import InputField from '../../../shared/form-elements/input';
import ModalBox from '../../../shared/modal';
import { formatMoney } from '../../../shared/format';

const Form = props => (
	<div className="transfer-edit__wrap">
		<form action="" className="ui-form" onSubmit={props.handleSubmit(data => props.transferFormSubmit(data))}>
			<div className="ui-form__element">
				<Field
					name="purseFrom"
					placeholder={props.intl('Purse From')}
					component={SelectField}
					searchable={false}
					clearable={false}
					options={props.purses}
				/>
			</div>
			<div className="ui-form__element">
				<Field name="purse" placeholder={props.intl('Purse to')} component={InputField} />
			</div>
			<div className="ui-form__element amount">
				<Field
					name="amount"
					placeholder={props.intl('Amount')}
					component={InputField}
					normalize={value => formatMoney(value, false)}
				/>
			</div>
			<div className="ui-form__element">
				<Field name="desc" placeholder={props.intl('Description')} component={TextField} />
			</div>
			<div className="ui-form__element buttons-wrap">
				<button className="ui-btn ui-btn-primary">{props.intl('Transfer')}</button>
			</div>
		</form>
	</div>
);

const Main = props => (
	<ModalBox
		title={props.intl('Create transfer')}
		body={Form(props)}
		isOpen={props.shouldShowTransferForm}
		onClose={props.toggleTransferForm}
		className="create-transfer-modal"
	/>
);

Form.propTypes = {
	intl: PropTypes.func,
	handleSubmit: PropTypes.func,
	purses: PropTypes.Object,
	transferFormSubmit: PropTypes.func
};

Main.propTypes = {
	intl: PropTypes.func,
	shouldShowTransferForm: PropTypes.bool,
	toggleTransferForm: PropTypes.func
};

export default formName =>
	reduxForm({
		form: formName
	})(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/wm/components/transfer-form/main.js